import { ReactElement, useMemo } from 'react';
import { useSettingsSlice } from '../../../../../../store/slices/settings/selectors';
import { useModifiers } from '../../../../../../styles/hooks';
import { L12nText } from '../../../../../text/L12nText';
import Dice1 from './assets/dice/1.svg';
import Dice2 from './assets/dice/2.svg';
import Dice3 from './assets/dice/3.svg';
import Dice4 from './assets/dice/4.svg';
import Dice5 from './assets/dice/5.svg';
import Dice6 from './assets/dice/6.svg';
import styles from './MegaSicBacHistoryResult.module.css';

export type Dice = '1' | '2' | '3' | '4' | '5' | '6';
export interface MegaSicBacResultProps {
  result: string;
  seats: {
    hand: {
      dice: [Dice, Dice];
      score: string;
    };
  }[];
}

export const diceImage: Record<Dice, string> = {
  '1': Dice1,
  '2': Dice2,
  '3': Dice3,
  '4': Dice4,
  '5': Dice5,
  '6': Dice6,
};

export default function MegaSicBacHistoryResult({ result, seats }: MegaSicBacResultProps): ReactElement {
  const emptyResult = useMemo(() => {
    return result === 'CANCELLED' || !seats[0] || !seats[1];
  }, [seats, result]);
  const locale = useSettingsSlice.currentLanguage();
  const historyLeftMods = useModifiers(
    styles,
    'container_left',
    {
      BN: locale === 'bn',
    },
    { withBaseClass: true }
  );

  const historyRightMods = useModifiers(
    styles,
    'container_right',
    {
      BN: locale === 'bn',
    },
    { withBaseClass: true }
  );
  return (
    <>
      {!emptyResult ? (
        <div className={styles.container}>
          <div className={historyLeftMods}>
            <span>
              <L12nText tk="PLAYER_CAPS" />: {seats[1].hand.score}
            </span>
          </div>
          <div className={historyRightMods}>
            <span>
              <L12nText tk="BANKER_CAPS" />: {seats[0].hand.score}
            </span>
          </div>
          <div className={styles.leftDice}>
            <img src={diceImage[seats[1].hand.dice[0]]} alt="playerDice1" />
            <img src={diceImage[seats[1].hand.dice[1]]} alt="playerDice2" />
          </div>
          <div className={styles.rightDice}>
            <img src={diceImage[seats[0].hand.dice[0]]} alt="bankerDice1" />
            <img src={diceImage[seats[0].hand.dice[1]]} alt="bankerDice2" />
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
